import React from "react"
import YourTests from "../components/YourTests"

const YourTestsView = () => <YourTests />

export default YourTestsView
